export interface GetOrganizationChecklistDto {
    id: string;
    name: string;
    tasks: string[];
    flis: string[] | null;
    organizationId?: string;
    originalChecklistId?: string;
    isDefault?: boolean;
    createdAt: Date;
    updatedAt: Date;
    updatedBy: string;
    disableSelection?: boolean;
}
